import React, { useEffect, useState } from 'react';
import { Link, Outlet } from 'react-router-dom';
import { auth, db } from '../../common/firebase';
import { signOut, onAuthStateChanged } from 'firebase/auth';
import { collection, getDocs } from 'firebase/firestore/lite';
import LoginModal from './LoginModal';
import '../styles/AdminLayout.css';  // 레이아웃 스타일

export default function AdminLayout() {
  const [isAuth, setIsAuth] = useState(false);
  const [totalInquiries, setTotalInquiries] = useState(0);
  const [unreadInquiries, setUnreadInquiries] = useState(0);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, user => {
      setIsAuth(!!user);
    });
    return unsub;
  }, []);

  useEffect(() => {
    if (!isAuth) return;
    let cancelled = false;

    const fetchCounts = async () => {
      try {
        const snap = await getDocs(collection(db, 'contacts'));
        if (cancelled) return;
        const all = snap.docs.map(d => d.data());
        setTotalInquiries(all.length);
        setUnreadInquiries(all.filter(item => !item.checked).length);
      } catch (err) {
        console.error('문의 카운트 조회 실패 ▶', err);
      }
    };

    fetchCounts();
    const interval = setInterval(fetchCounts, 5000);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [isAuth]);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      setIsAuth(false);
    } catch (err) {
      console.error('Logout Error ▶', err);
      alert('⚠️ 로그아웃 실패: 다시 시도해주세요.');
    }
  };

  if (!isAuth) {
    return <LoginModal />;
  }

  return (
    <div className="admin-root">
      {/* 상단 Topbar */}
      <header className="admin-topbar">
        {/* 첫 줄: 로고, 햄버거 버튼, 로그아웃 버튼 */}
        <div className="topbar-row">
          <div className="logo-container">
            <Link to="/">
              <img src="/logo.png" alt="TravelMate Logo" className="logo-img" />
            </Link>
            <div className="logo-text">TravelMate Admin</div>
          </div>

          <button
            type="button"
            className="sidebar-toggle"
            aria-label="사이드바 열기/닫기"
            onClick={() => setSidebarOpen(prev => !prev)}
          >
            ☰
          </button>

          {/* 📱 모바일 전용(기존 자리 유지) */}
          <button
            type="button"
            className="logout-btn mobile-only"
            onClick={handleLogout}
          >
            로그아웃
          </button>
        </div>

        {/* 둘째 줄: 알림 / 문의 수 */}
        <div className="topbar-actions">
          <span className="status">
            🔔 알림 {unreadInquiries} &nbsp;&nbsp;📧 문의 {totalInquiries}
          </span>
          {/* 🖥️ 데스크톱 전용(알림·문의 뒤) */}
          <button
            type="button"
            className="logout-btn desktop-only"
            onClick={handleLogout}
          >
            로그아웃
          </button>
        </div>
      </header>
      <div className="admin-body">
        <nav className={`admin-sidebar ${sidebarOpen ? 'open' : ''}`}>
          <ul>
            <li><Link to="/admin" onClick={() => setSidebarOpen(false)}>대시보드</Link></li>
            <li><Link to="/admin/sections" onClick={() => setSidebarOpen(false)}>랜딩페이지 설정</Link></li>
            <li><Link to="/admin/submissions" onClick={() => setSidebarOpen(false)}>문의내역</Link></li>
          </ul>
        </nav>

        <main
          className="admin-content"
          onClick={() => {
            if (sidebarOpen) setSidebarOpen(false);
          }}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
}
